import { render, staticRenderFns } from "./mydata.vue?vue&type=template&id=17aaae83&scoped=true&"
import script from "./mydata.vue?vue&type=script&lang=js&"
export * from "./mydata.vue?vue&type=script&lang=js&"
import style0 from "./mydata.vue?vue&type=style&index=0&id=17aaae83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aaae83",
  null
  
)

export default component.exports